import axios from '~/util/axios'

export default {
  get (sac) {
    return axios.post('/api/v1/custom_ui_theme', {
      sac: sac
    })
  }
}
